// removed by extract-text-webpack-plugin
module.exports = {"TextFrame":"BSGrid__TextFrame__1cjYO","BSGridHeader":"BSGrid__BSGridHeader__1XNKq","BSGrid":"BSGrid__BSGrid__2-pmc","Alt":"BSGrid__Alt__RM-EX","Wide":"BSGrid__Wide__1Rj4O","Tall":"BSGrid__Tall__1fLdm","Squared1":"BSGrid__Squared1__19fGy","Squared2":"BSGrid__Squared2__1YmDD"};


//////////////////
// WEBPACK FOOTER
// ./src/components/BSGrid/BSGrid.css
// module id = 203
// module chunks = 0